<template>
  <div>
    <draggable
      animation="200"
      drag-class="t-opacity-0"
      handle=".cxm-Dots"
      :list="list"
    >
      <slot />
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
